import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Section, SectionTitle } from '@/components/shared/Section';
import { FAQS } from '@/data/venddi';

export default function VenddiFAQs() {
  const [open, setOpen] = useState(0);
  return (
    <Section>
      <SectionTitle
        badge="FAQs"
        title="Preguntas frecuentes"
        subtitle="Lo que nos preguntan los gerentes antes de firmar."
        center
      />
      <div className="max-w-3xl mx-auto space-y-3">
        {FAQS.map((f, i) => (
          <div key={i} className="rounded-xl bg-white border border-slate-200 overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-slate-50 transition-colors"
              data-testid={`venddi-faq-${i}`}
            >
              <span className="text-sm font-semibold text-[#0A2540]" style={{ fontFamily: 'Syne,sans-serif' }}>{f.q}</span>
              <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
            </button>
            {open === i && (
              <div className="px-5 pb-5 text-sm text-slate-600 leading-relaxed border-t border-slate-100 pt-3">
                {f.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
}
